// extracted by mini-css-extract-plugin
module.exports = {"worker-badge":"WorkerBadge_worker-badge_sBmDh","selected":"WorkerBadge_selected_2l63t"};